import { ClockLine, CloseLine } from "@dropbox/dig-icons/assets";
import { typeahead } from "@mirage/service-typeahead-search/service/types";

import { IconButton } from "@dropbox/dig-components/buttons";
import { UIIcon } from "@dropbox/dig-icons";
import { DigTooltip } from "@mirage/shared/util/DigTooltip";
import i18n from "@mirage/translations";

import { BaseResultRow } from "./BaseResultRow";

export type BaseRecentsResultRowProps<T extends typeahead.ScoredResult> = {
  title: string;
  scoredResult: T;
  isSelected: boolean;
  handleRemove?: (result: T) => void;
};

export const BaseRecentsResultRow = <T extends typeahead.ScoredResult>({
  scoredResult,
  handleRemove,
  isSelected,
  title,
}: BaseRecentsResultRowProps<T>) => {
  return (
    <BaseResultRow
      icon={<UIIcon src={ClockLine} color={"var(--dig-color__text__base)"} />}
      title={title}
      accessory={
        <DigTooltip title={i18n.t("tooltip_remove_recent_result")}>
          <IconButton
            variant="borderless"
            size="medium"
            aria-label={i18n.t("aria_remove_recent_result")}
            onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
              e.stopPropagation();
              handleRemove?.(scoredResult);
            }}
          >
            <UIIcon src={CloseLine} />
          </IconButton>
        </DigTooltip>
      }
      showAccessory={isSelected}
    />
  );
};
BaseRecentsResultRow.displayName = "BaseRecentsResultRow";
